"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _imeiRequest = require("@/api/imei-request");
var _RequestImeiModal = _interopRequireDefault(require("./components/RequestImeiModal.vue"));
var _RequestImeiByAgency = _interopRequireDefault(require("./components/RequestImeiByAgency.vue"));
var _enum = require("@/types/enum");
var _ImeiRequestHistoryTable = _interopRequireDefault(require("./components/ImeiRequestHistoryTable.vue"));
var _ImeiRequestCheckTable = _interopRequireDefault(require("./components/ImeiRequestCheckTable.vue"));
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)({
  components: {
    Pagination: _Pagination.default,
    RequestImeiByAgency: _RequestImeiByAgency.default,
    RequestImeiModal: _RequestImeiModal.default,
    ImeiRequestHistoryTable: _ImeiRequestHistoryTable.default,
    ImeiRequestCheckTable: _ImeiRequestCheckTable.default
  },
  created: function created() {
    this.getTableData();
  },
  data: function data() {
    return {
      loadingButtonExcel: false,
      objData: {
        imei: ""
      },
      loadingSubmit: false,
      loadingRemove: false,
      totalRecord: 0,
      arrDevice: [],
      listLoading: false,
      tableData: [],
      total: 0,
      data: [],
      successImeis: [],
      failImeis: [],
      expiredImeis: [],
      loadingCheck: false,
      query: {
        page: 1,
        limit: 10
      },
      tableLoading: false,
      checkImeiList: []
    };
  },
  watch: {
    "objData.imei": function objDataImei(val) {
      var arr = val.split("\n");
      var res = arr.filter(function (item) {
        if (item) return item;
      });
      this.totalRecord = res.length;
    }
  }
}, "created", function created() {
  // this.fetchData();
}), "methods", {
  handleQuery: function handleQuery(_ref) {
    var userLevelIds = _ref.userLevelIds,
      from = _ref.from,
      to = _ref.to;
    this.query = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), userLevelIds), {}, {
      from: from,
      to: to
    });
    this.fetchData();
  },
  checkImeis: function checkImeis() {
    var _this = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      var imeis, res, data;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            imeis = _this.objData.imei.split("\n").filter(function (e) {
              return e;
            });
            _this.loadingCheck = true;
            _context.prev = 2;
            _context.next = 5;
            return _imeiRequest.imeiRequestApi.checkReceive({
              imeis: imeis
            });
          case 5:
            res = _context.sent;
            data = res.data;
            _this.checkImeiList = data;
            _this.successImeis = data.filter(function (e) {
              return e.status == _enum.ImeiRequestStatus.valid;
            });
            _this.failImeis = data.filter(function (e) {
              return e.status == _enum.ImeiRequestStatus.invalid;
            });
            _this.expiredImeis = data.filter(function (e) {
              return e.status == _enum.ImeiRequestStatus.expired;
            });
            console.log("checkImeis", res.data);
          case 12:
            _context.prev = 12;
            _this.loadingCheck = false;
            return _context.finish(12);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2,, 12, 15]]);
    }))();
  },
  handleOpen: function handleOpen(row) {
    this.$refs.RequestImeiModal.handleOpen(row.id);
  },
  resetForm: function resetForm() {
    this.successImeis = [];
    this.data = [];
    this.failImeis = [];
    this.objData.imei = "";
    this.checkImeiList = [];
    this.successImeis = [];
    this.expiredImeis = [];
  },
  fetchData: function fetchData() {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
      var res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this2.listLoading = true;
            _context2.next = 3;
            return _imeiRequest.imeiRequestApi.findAll((0, _objectSpread2.default)({}, _this2.query));
          case 3:
            res = _context2.sent;
            _this2.listLoading = false;
            _this2.data = res.data.data;
            _this2.total = res.data.total;
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  handleRequest: function handleRequest() {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
      var imeis, res;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            imeis = _this3.checkImeiList;
            _this3.loadingSubmit = true;
            _context3.prev = 2;
            _context3.next = 5;
            return _imeiRequest.imeiRequestApi.create({
              imeis: imeis,
              success: _this3.successImeis.length,
              fail: _this3.failImeis.length,
              expired: _this3.expiredImeis.length
            });
          case 5:
            res = _context3.sent;
            _this3.$message.success("Request success ".concat(imeis.length, " imeis"));
            _this3.fetchData();
            _this3.resetForm();
          case 9:
            _context3.prev = 9;
            _this3.loadingSubmit = false;
            return _context3.finish(9);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2,, 9, 12]]);
    }))();
  }
});